import Image from 'next/image'
import DefaultImage from '#/assets/images/blog/default.png'
import Link from '#/components/Link'
import { logEvent } from '#/services/analytics'
import Avatar from './avatar'
import CoverImage from './cover-image'

interface HeroProps {
  title: string
  coverImage: Blog.Image
  date: string
  excerpt: string
  author: Blog.Author
  slug: string
  category: string
}

const HeroPost: React.FC<HeroProps> = ({
  title,
  coverImage,
  date,
  excerpt,
  author,
  slug,
  category
}) => {
  function logCardClick(name: string) {
    logEvent('select_content', {
      content_type: 'blog',
      item_id: 'open_post',
      value: `${name}`
    })
  }
  return (
    <Link href={`/blog/posts/${slug}`} onClick={() => logCardClick(slug)}>
      <div className='mx-auto flex max-w-sm cursor-pointer flex-col overflow-hidden rounded-lg shadow-sm md:max-w-none md:flex-row'>
        <div className='h-48 max-h-96 shrink-0 overflow-hidden md:h-auto md:w-7/12'>
          {coverImage ? (
            <CoverImage
              coverImage={coverImage}
              height='h-48 md:h-96'
              slug={slug}
              title={title}
            />
          ) : (
            <div className='h-1/2'>
              <Image
                alt='Default'
                src={DefaultImage}
              />
            </div>
          )}
        </div>

        <div className='flex flex-1 flex-col justify-between bg-white p-6 md:w-5/12 lg:px-8'>
          <div className='flex-1'>
            <p className='text-sm font-medium tracking-wide text-indigo-600'>
              {category}
            </p>
            <div className='mt-3 block lg:mt-3'>
              <p
                dangerouslySetInnerHTML={{ __html: title }}
                className='line-clamp-4 cursor-pointer text-lg font-semibold text-gray-800 sm:text-xl md:text-xl lg:text-3xl'
              />
              <div
                dangerouslySetInnerHTML={{ __html: excerpt }}
                className='mt-3 line-clamp-3 text-base text-gray-500 md:line-clamp-6 lg:mt-6 lg:line-clamp-4 lg:leading-6 xl:line-clamp-5'
              />
            </div>
          </div>
          <div className='mt-6 flex items-center'>
            <Avatar author={author} dateString={date} dimensions='h-12 w-12' />
          </div>
        </div>
      </div>
    </Link>
  )
}

export default HeroPost
